import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {title: '工作站'},
      component: index
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js